export default function () {
  return {
    current: {
      active: null,
      alarmed: '',
      alarms: [],
      allowUpgrade: false,
      gitTagVersion: '',
      approvedGitVersions: [],
      autoAssignName: false,
      backupContent: '',
      backupsCount: 0,
      backupsSize: 0,
      backupMethod: '',
      branch: '',
      backups: [],
      clientVersion: '',
      contractStatus: '',
      coreUpdates: false,
      filesets: [],
      forceDue: false,
      id: '',
      internalIp: '',
      ip: '',
      keyConnected: false,
      kind: '', // aka. platform
      lastBackup: '',
      lastBackupLog: '',
      lastBackupStatus: '',
      lastConnection: '',
      lastLog: '',
      name: '',
      notes: '',
      organization: '',
      password: '',
      projectManager: '',
      purgeList: [],
      reenableTime: null,
      retention: '',
      server: '',
      softwareRole: '',
      softwareVersion: '',
      tempZipLocation: '',
      username: ''
    },
    update: {
      active: null,
      alarmed: '',
      allowUpgrade: false,
      gitTagVersion: '',
      autoAssignName: false,
      backupContent: '',
      backupMethod: '',
      branch: '',
      contractStatus: '',
      coreUpdates: false,
      forceDue: false,
      id: '',
      kind: '', // aka. platform
      name: '',
      notes: '',
      password: '',
      reenableTime: null,
      retention: '',
      server: '',
      tempZipLocation: '',
      username: ''
    },
    alarms: [],
    count: 0,
    // set right after a system is created so the settings page can call attention
    // to the auto-assigned Content once; consumed (cleared) by that page
    highlightContent: false,
    kinds: [ // aka. platform
      'ACC',
      'ACM',
      'Ademco',
      'Aiphone',
      'Axis',
      'Bosch',
      'Continuum',
      'Dectron',
      'EcoStruxure',
      'ExacqVision',
      'Firelite',
      'Gamewell',
      'Generic',
      'Genetec',
      'Informacast',
      'Milestone',
      'Niagara',
      'Paxton',
      'Reliable Controls',
      'Samsung',
      'Security Expert',
      'Vertiv',
      'VideoXpert'
    ],
    list: [],
    not_backedup_list: [],
    ok: 0,
    overdue_list: [],
    s3BackupsList: []
  }
}
